export default "__VITE_ASSET__BtrfUt99__"